// Бейдж статуса тикета: open/waiting_mod/waiting_user/closed/spam.
import React from "react";

const LABELS = {
  open: "Открыто",
  waiting_mod: "Ждёт ответа МИНа",
  waiting_user: "Ждёт ответа",
  closed: "Закрыто",
  spam: "Спам",
};

export default function TicketStatusBadge({ status }) {
  return (
    <span className={`sup-status sup-status--${status}`}>
      {LABELS[status] || status}
    </span>
  );
}
